import {
  Box,
  Paper,
  FormControl,
  Input,
  InputLabel,
  CardContent,
  FormControlLabel,
  Card,
  TextField,
  Checkbox,
  Button,
  CircularProgress,
} from "@mui/material"
import { useState, useEffect } from "react"
import { Trans, useTranslation } from "react-i18next"
import ContactForm from "./SecondaryForms/ContactForm"
import { Contact } from "../model/Contact"
import { initialState as initialStateRetraitPlainte } from "./InitialStates/RetraitPlainteInitialState"
import axios from "axios"
import Turnstile, { useTurnstile } from "react-turnstile"
import "./CSS/colorMessages.css"
import appendObjectToFormData from '../utils/useFormData'
import { useNavigate } from "react-router-dom"

const decodeHtmlEntities = (text: string | null = ''): string => {
  return text 
    ? text
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
    : '';
};
const FormulaireRetraitPlaintes = () => {
  let navigate = useNavigate()
  const [retraitPlainte, setRetraitPlainte] = useState(
    initialStateRetraitPlainte
  )
  const [reCaptchaRequest, setReCaptcha] = useState({ reCaptchaToken: "", remoteip: null })
  const [successForm, setSuccessForm] = useState("")
  const [errorSubmission, setErrorSubmission] = useState("")
  const [
    errorAttestationRetraitVolontaire,
    setErrorAttestationRetraitVolontaire,
  ] = useState("")
  const [errorNom, setErrorNom] = useState("")
  const [errorContactNom, setErrorContactNom] = useState("")
  const [errorContactPrenom, setErrorContactPrenom] = useState("")
  const [errorContactTitre, setErrorContactTitre] = useState("")
  const [errorContactCourriel, setErrorContactCourriel] = useState("")
  const [errorContactTelephone, setErrorContactTelephone] = useState("")
  const [errorMotifs, setErrorMotifs] = useState("")
  const [
    errorAttestationVeraciteInformations,
    setErrorAttestationVeraciteInformations,
  ] = useState("")
  const { t } = useTranslation()
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.title = "Retrait plainte"
  }, [])

  const goToConfirmation = () => {
    return navigate("/confirmation")
  }

  const handleOnChange = (event: any) => {
    const { name, value } = event.target
    setRetraitPlainte((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }

  const handleContactChange = (updatedContact: Contact) => {
    setRetraitPlainte((prevState) => ({
      ...prevState,
      contact: updatedContact,
    }))
  }

  const handleAttestationRetraitOnChange = (event: any) => {
    setRetraitPlainte((prevState) => {
      return {
        ...prevState,
        ['attestationRetraitVolontaire']: !retraitPlainte.attestationRetraitVolontaire,
      }
    })
  }

  const handleAttestationVeraciteOnChange = (event: any) => {
    setRetraitPlainte((prevState) => {
      return {
        ...prevState,
        ['attestationVeraciteInformations']: !retraitPlainte.attestationVeraciteInformations,
      }
    })
  }

  const TurnstileWidget = () => {
    const turnstile = useTurnstile()
    return (
      <Turnstile
        sitekey="0x4AAAAAAATUkYKisAyqVMcx"
        onVerify={async (token) => {
          const res = await axios.get("https://api.ipify.org/?format=json")
          setReCaptcha({ reCaptchaToken: token, remoteip: res.data.ip })
        }}
      />
    )
  }

  useEffect(() => {
    handleErrors()
  }, [retraitPlainte])

  const handleErrors = () => {
    if (errorAttestationRetraitVolontaire === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.attestationRetraitVolontaire) {
      setErrorAttestationRetraitVolontaire("")
    }
    if (errorContactNom === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.contact.nom !== "") {
      setErrorContactNom("")
    }
    if (errorContactPrenom === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.contact.prenom !== "") {
      setErrorContactPrenom("")
    }
    if (errorContactTitre === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.contact.titre !== "") {
      setErrorContactTitre("")
    }
    if (errorContactCourriel === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.contact.courriel !== "") {
      setErrorContactCourriel("")
    }
    if (errorContactTelephone === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.contact.telephone !== "") {
      setErrorContactTelephone("")
    }
    if (errorAttestationVeraciteInformations === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.attestationVeraciteInformations) {
      setErrorAttestationVeraciteInformations("")
    }
    if (errorMotifs === t("messagesUtilisateurs.lblChampRequis") && retraitPlainte.motifsRetrait !== "") {
      setErrorMotifs("")
    }
  }

  const handleFormatErrors = (fieldName: string) => {
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (fieldName === "courriel") {
      if (
        retraitPlainte.contact.courriel !== "" &&
        !regexCourriel.test(retraitPlainte.contact.courriel)
      ) {
        setErrorContactCourriel(
          t("messagesUtilisateurs.lblContactFormatCourriel")
        )
      } else setErrorContactCourriel("")
    }
    else if (fieldName === "telephone") {
      if (
        retraitPlainte.contact.telephone !== "" &&
        !regexTelephone.test(retraitPlainte.contact.telephone)
      ) {
        setErrorContactTelephone(
          t("messagesUtilisateurs.lblContactFormatTelephone")
        )
      } else setErrorContactTelephone("")
    }
  }

  const handleSubmit = () => {
    let error = false
    if (!retraitPlainte.attestationRetraitVolontaire) {
      setErrorAttestationRetraitVolontaire(
        t("messagesUtilisateurs.lblChampRequis")
      )
      error = true
    } else setErrorAttestationRetraitVolontaire("")
    if (retraitPlainte.personneAddressantPlainte === "") {
      setErrorNom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorNom("")
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (retraitPlainte.contact.nom === "") {
      setErrorContactNom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactNom("")
    if (retraitPlainte.contact.prenom === "") {
      setErrorContactPrenom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactPrenom("")
    if (retraitPlainte.contact.courriel === "") {
      setErrorContactCourriel(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactCourriel("")
    if (retraitPlainte.contact.telephone === "") {
      setErrorContactTelephone(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactTelephone("")
    if (
      retraitPlainte.contact.courriel !== "" &&
      !regexCourriel.test(retraitPlainte.contact.courriel)
    ) {
      setErrorContactCourriel(
        t("messagesUtilisateurs.lblContactFormatCourriel")
      )
      error = true
    } else if (retraitPlainte.contact.courriel !== "")
      setErrorContactCourriel("")
    if (
      retraitPlainte.contact.telephone !== "" &&
      !regexTelephone.test(retraitPlainte.contact.telephone)
    ) {
      setErrorContactTelephone(
        t("messagesUtilisateurs.lblContactFormatTelephone")
      )
      error = true
    } else if (retraitPlainte.contact.telephone !== "")
      setErrorContactTelephone("")
    if (retraitPlainte.motifsRetrait === "") {
      setErrorMotifs(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorMotifs("")
    if (!retraitPlainte.attestationVeraciteInformations) {
      setErrorAttestationVeraciteInformations(
        t("messagesUtilisateurs.lblChampRequis")
      )
      error = true
    } else setErrorAttestationVeraciteInformations("")
    if (error) setErrorSubmission(t("messagesUtilisateurs.lblErreurChampsFormulaire"))
    if (!error) {

      const formData = new FormData()
      appendObjectToFormData(formData, 'retraitPlainteForm', retraitPlainte)
      appendObjectToFormData(formData, 'contactForm', retraitPlainte.contact)
      appendObjectToFormData(formData, 'reCaptchaRequest', reCaptchaRequest)
      formData.append('nomFormulaire', 'RetraitPlainte')
      formData.append('nomEntrepriseOuIndividu', retraitPlainte.personneAddressantPlainte)
      formData.append('adresseCourriel', retraitPlainte.contact.courriel)

      setLoading(true)
      setSaved(true)
      axios
        .post(
          process.env.REACT_APP_API_URL + "/v1/TraiterFormulaires/upload",
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
        )
        .then((response) => {
          setSaved(true)
          setSuccessForm(t("messagesUtilisateurs.lblSuccesSoumission"))
          setErrorSubmission("")
          goToConfirmation()
        })
        .catch((error) => {
          setSaved(false)
          setSuccessForm("")
          setErrorSubmission(t("messagesUtilisateurs.lblErreurEnvoiFormulaire"))
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        })
    }
    else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }

  return (
    <>
      <Card className="card" sx={{ minWidth: 275 }}>
        <CardContent>
          <Box component="form" sx={{ "& > :not(style)": { m: 1 } }}>
            {successForm && (
              <strong id="success" role="alert" className="success">
                <Trans>{successForm}</Trans>
              </strong>
            )}

            {errorSubmission && (
              <strong id="error-submission" role="alert" className="error">
                <Trans>{errorSubmission}</Trans>
              </strong>
            )}
            <div className="amp-alert amp-alert--warning">
              <div className="amp-alert__body">
                <div className="field">
                  <p><Trans>{t("formulaireRetraitPlainte.info")}</Trans></p>
                </div>
              </div>
            </div>
            <FormControl fullWidth>
              <h1>
               <Trans>{t("formulaireRetraitPlainte.lblPage")}</Trans>
              </h1>
            </FormControl>

            <div className="form-section-label-margin">
              <Trans>
                {t("formulaireRetraitPlainte.attestationIdentificationPlainte.lblSection")}
              </Trans>
            </div>


            <FormControl fullWidth>
              <div className="form-attestation">
                <div className="form-text-label-no-margin">
                  <Trans>{t("attestations.retraitPlainte.lbl")}</Trans>
                </div>
                <FormControlLabel
                  required
                  control={<Checkbox />}
                  name="attestationRetraitVolontaire"
                  onChange={handleAttestationRetraitOnChange}
                  label={
                    <Trans>{t("attestations.retraitPlainte.message")}</Trans>
                  }
                  aria-describedby="attestation-retrait-error"
                  style={{ backgroundColor: errorAttestationRetraitVolontaire ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                />
              </div>
            </FormControl>


            {errorAttestationRetraitVolontaire && (
              <strong
                id="attestation-retrait-error"
                role="alert"
                className="error"
              >
                <Trans>{errorAttestationRetraitVolontaire}</Trans>
              </strong>
            )}

            <FormControl fullWidth>
              <InputLabel htmlFor="code-retrait">
                <Trans>
                  {t(
                    "formulaireRetraitPlainte.attestationIdentificationPlainte.lblCodeRetrait"
                  )}
                </Trans>
              </InputLabel>
              <Input
                id="code-retrait"
                name="codeRetrait"
                value={retraitPlainte.codeRetrait}
                onChange={handleOnChange}
              />
            </FormControl>

            <div className="form-section-label">
              <Trans>
                {t(
                  "formulaireRetraitPlainte.identificationPlaignantRep.lblSection"
                )}
              </Trans>
            </div>

            <FormControl fullWidth>
              <TextField required id="nom-entreprise"
                name="personneAddressantPlainte"
                label={
                  <Trans>
                    {t(
                      "formulaireRetraitPlainte.identificationPlaignantRep.lblNomEntreprise"
                    )}
                  </Trans>
                }

                onChange={handleOnChange}
                value={decodeHtmlEntities(retraitPlainte.personneAddressantPlainte || '')}
                aria-describedby="nom-error"
                style={{ backgroundColor: errorNom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
              {errorNom && (
              <strong id="nom-error" role="alert" className="error">
                <Trans>{errorNom}</Trans>
              </strong>
            )}
            </FormControl>

            

            <div className="form-text-label">
              <Trans>
                {t(
                  "formulaireRetraitPlainte.identificationPlaignantRep.lblContact"
                )}
              </Trans>
            </div>

            <ContactForm
              contact={retraitPlainte.contact}
              onChange={handleContactChange}
              onBlur={handleFormatErrors}
              errorContactNom={errorContactNom}
              errorContactPrenom={errorContactPrenom}
              errorContactCourriel={errorContactCourriel}
              errorContactTelephone={errorContactTelephone}
            />



            <div className="form-section-label">
              <Trans>
                {t("formulaireRetraitPlainte.motifRetraitPlainte.lblSection")}
              </Trans>
            </div>

            <FormControl fullWidth>
              <TextField required
                name="motifsRetrait"
                label={
                  <Trans>
                    {t(
                      "formulaireRetraitPlainte.motifRetraitPlainte.lblDescription"
                    )}
                  </Trans>
                }

                multiline
                rows={4}
                onChange={handleOnChange}
                value={decodeHtmlEntities(retraitPlainte.motifsRetrait|| '')}
                aria-describedby="motifs-error"
                style={{ backgroundColor: errorMotifs ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
              {errorMotifs && (
              <strong id="motifs-error" role="alert" className="error">
                <Trans>{errorMotifs}</Trans>
              </strong>
            )}
            </FormControl>

            
            <Paper elevation={2}>
              <FormControl fullWidth>
                <div className="form-attestation">
                  <div className="form-text-label-no-margin">
                    <Trans>{t("attestations.veraciteRenseignement.lbl")}</Trans>
                  </div>
                  <FormControlLabel
                    required
                    control={<Checkbox />}
                    name="attestationVeraciteInformations"
                    onChange={handleAttestationVeraciteOnChange}
                    label={
                      <Trans>
                        {t("attestations.veraciteRenseignement.message")}{" "}
                      </Trans>
                    }
                    aria-describedby="attestation-veracite-error"
                    style={{ backgroundColor: errorAttestationVeraciteInformations ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                </div>
                {errorAttestationVeraciteInformations && (
              <strong
                id="attestation-veracite-error"
                role="alert"
                className="error"
              >
                <Trans>{errorAttestationVeraciteInformations}</Trans>
              </strong>
            )}
              </FormControl>
            </Paper>

            

            {TurnstileWidget()}

            <div>
              <FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={saved}
                >
                  <Trans>
                    {t(
                      "formulaireRetraitPlainte.motifRetraitPlainte.ctaSoumettre"
                    )}
                  </Trans>
                  {loading && (<CircularProgress />)}
                </Button>
              </FormControl>
            </div>
          </Box>
        </CardContent>
      </Card>
    </>
  )
}

export default FormulaireRetraitPlaintes
